import { Template } from '@/gql/graphql';

export const isTemplateTailoringEnabled = (userId: string, template?: Template) => {
  if (!template) return false;
  return template.owner.id === userId;
};

export const isTemplateEditEnabled = (userId: string, template?: Template) => {
  if (!template) return false;
  return template.owner.id === userId;
};

export const isTemplateStatusChangeEnabled = (userId: string, template?: Template) => {
  if (!template) return false;
  return template.owner.id === userId;
};

export const isTemplateDeleteEnabled = (userId: string, template?: Template) => {
  if (!template) return false;
  return template.owner.id === userId;
};
